import React from 'react';
import { type Extension } from '../web-client';

interface RendererContextProps {
	appDomainName?: string;
	egress?: Extension['egress'];
	extensionType?: Extension['type'];
	forgeEnvironment?: Extension['environmentType'];
	forgeReactMajorVersion?: number;
	properties?: Extension['properties'];
}

export const RendererContext = React.createContext<RendererContextProps>({});
